<template>
  <div class="">
    <div class="head-title">知识库</div>
    <div class="">
      <div class="bottom_right">
        <div class="listtow">
          <!-- <div>
            <a class="title">
              <div>文档名称</div>
              <div>上传时间</div>
              <div>操作</div>
            </a>
            <div
              class="noneed"
              v-for="(item, index) in ddsec.data"
              :key="index"
            >
              <a
                class="titles"
                v-if="item.knowledge_image.length > 1"
                :href="item.knowledge_image"
                target="_blank"
              >
                <div>{{ item.title }}</div>
                <div>{{ item.addtime }}</div>
                <div><img src="../../../assets/xiazai.png" alt="" /></div>
              </a>
              <a
                class="titles"
                v-else-if="item.knowledge_image.length == 0"
                @click="aacsi"
              >
                <div>{{ item.title }}</div>
                <div>{{ item.addtime }}</div>
                <div><img src="../../../assets/xiazai.png" alt="" /></div>
              </a>
            </div>
          </div> -->

          <el-table
            :data="ddsec.data"
            stripe=""
            border=""
            style="margin-top: 2.0rem"
          >
            <el-table-column prop="title" label="文档名称"> </el-table-column>
            <el-table-column prop="addtime" label="上传时间"> </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                >
                  <a
                    v-if="scope.row.knowledge_image.length > 1"
                    :href="scope.row.knowledge_image"
                    target="_blank"
                    style="color:#fff;"
                    rel="noopener noreferrer"
                    >查看</a
                  >
                  <a
                    v-else-if="scope.row.knowledge_image.length == 0"
                    style="color:#fff;"
                    rel="noopener noreferrer"
                    @click="aacsi"
                    >查看</a
                  >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="ddsec.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="buseer"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "mine",
  data() {
    return {
      title: {},
      username: {},
      tabodata: {},
      defaultProps: {
        children: "data",
        label: "name",
      },
      ddsec: {
        total: 0,
        data: [],
      },
      page: {},
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    //    if (window.sessionStorage.getItem("title")) {
    //       let title = JSON.parse(window.sessionStorage.getItem("title"));
    //       this.title = title;
    //       var a = document.title;
    //       document.title = title[0].website + "-" + a;
    //     }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
      // console.log(this.username);
      if (this.username.parent_id != 0) {
        this.username.parent_id = 1;
      }
    }
    this.buseer();
  },
  methods: {
    aacsi() {
      this.$message.error("无附件可下载");
    },
    buseer() {
      this.axios
        .post(
          "/api/notice/lookNotice",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            notice_category_id: "1",
            scope: this.username.parent_id,
            listQuery: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.ddsec = res.data.data;
        })
        .catch(function (err) {});
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleNodeClick();
    },
    handleNodeClick(data) {
      this.axios
        .post(
          "/api/notice/getNoticeList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            notice_category_id: data.id,
            page: this.page,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.ddsec = res.data.data;
        })
        .catch(function (err) {});
    },
    getNoticeCategoryList() {
      this.axios
        .post(
          "/api/NoticeCategory/getNoticeCategoryList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tabodata = res.data.data;
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tree-node__content {
  height: 5.0rem;
}
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #3A97EF;
  color: #fff;
}
::v-deep .el-tree-node__content {
  border-bottom: 1px solid #EEEEEE;
  color: #484848;
}
::v-deep .el-tree-node__content {
  padding: 2.0rem;
}
::v-deep .el-tree-node__label {
  font-size: 22px;
}
.mine {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: .0rem .0rem 12px .0rem rgba(97, 111, 180, 0.2);
}
.mine_body {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
}
.mine_body_nav {
  width: 100%;
  background-color: #3A97EF;
  line-height: 5.0rem;
  color: #fff;
  font-size: 22px;
  padding-left: 3.0rem;
}
.mine_body_bottom {
  width: 100%;
  height: 95%;
  display: flex;
}
.bottom_left {
  width: 20%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.bottom_left > div:nth-child(1) {
  width: 100%;
  padding: 2.0rem;
  background-color: #C8FAF5;
  color: #1A8BE5;
  font-size: 2.0rem;
}
.list {
  width: 100%;
  border-bottom: 1px solid #EEEEEE;
  color: #484848;
  font-size: 2.0rem;
}
.list:hover {
  background-color: #3A97EF;
  color: #fff;
}
.listtow {
  background-color: #3A97EF;
  color: #fff;
}
.bottom_right {
  height: 100%;
  background-color: #F8F8F8;
}
.listto {
  width: 100%;
  padding: 2.0rem;
  color: #1A8BE5;
  font-size: 2.0rem;
}
.listtow {
  height: 90%;
  background-color: #fff;
}
.listtow > div:nth-child(1) {
  width: 100%;
  height: 90%;
  overflow: hidden;
  overflow-y: auto;
}
.noneed {
  width: 100%;
  //   padding: 1.0rem;
  color: #5C5C5C;
  border-bottom: 1px solid #DCDCDC;
  //   background-color: red;
}
.noneed > .titles {
  display: flex;
  justify-content: space-between;
  padding: 2.0rem;
  color: #000000;
}
.titles:hover {
  background-color: #DCDCDC;
}
.title {
  display: flex;
  justify-content: space-between;
  padding: 2.0rem;
  background-color: #3A97EF;
  color: #fff;
}
</style>
